export const createCommunity = (payload) => {
    return {
        type: 'COMMUNITY_DATA',
        payload: payload
    }
}